__turbopack_context__.v({
  "bulletSeparator": "BulletSeparator-module-scss-module__rcqDsW__bulletSeparator",
});
